module.exports = __webpack_public_path__ + "img/xmzs.0e9d2986.svg";